import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
import { InfoDetails } from '../../Icons';
import { useTransitTooltip } from '../hooks';
import Tooltip from '../../BaseComponents/Tooltip';
import { useConfig } from '../../context';
import MediaQuery from '../../MediaQuery/MediaQuery';
import { ClickAwayListener } from '@mui/material';

const TransitTooltip: React.FC = () => {
	const { t } = useTranslation('FlightPrice');
	const { TransitTooltip: css } = useTheme('TransitTooltip');

	const {
		global: {
			companyInfo: { transferM2ConditionURL }
		}
	} = useConfig();

	const { open: openTransitTooltip, isOpen: isTransitTooltipOpen, close: closeTransitTooltip } = useTransitTooltip();

	return (
		<Tooltip
			open={isTransitTooltipOpen}
			titleClassName={css.transitTooltip__title}
			popperClassName={css.transitTooltip}
			title={
				<div
					onClick={e => e.stopPropagation()}
					onMouseOver={openTransitTooltip}
					onMouseLeave={closeTransitTooltip}
				>
					<div>{t('Special conditions for flight delays and ticket refunds')}</div>
					{transferM2ConditionURL && (
						<a href={transferM2ConditionURL} onClick={e => e.stopPropagation()} target="_blank">
							<div>{t('Full conditions')}</div>
						</a>
					)}
				</div>
			}
		>
			<div>
				<MediaQuery minWidth={'tablet'}>
					<a
						href={transferM2ConditionURL || null}
						onClick={e => e.stopPropagation()}
						target="_blank"
						className={css.transitTooltip__text}
						onMouseOver={openTransitTooltip}
						onMouseLeave={closeTransitTooltip}
					>
						{t('Transit tariff')} {InfoDetails}
					</a>
				</MediaQuery>

				<MediaQuery maxWidth={'tablet'}>
					<ClickAwayListener onClickAway={closeTransitTooltip}>
						<div className={css.transitTooltip__text} onClick={openTransitTooltip}>
							{t('Transit tariff')} {InfoDetails}
						</div>
					</ClickAwayListener>
				</MediaQuery>
			</div>
		</Tooltip>
	);
};

export default TransitTooltip;
